// extracted by mini-css-extract-plugin
export default {"container":"vM-z","dimension":"wM-z","dimensionLabels":"xM-z"};